/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

import {Component, Prop, Vue} from 'vue-property-decorator';

import {UgcBuildInterface} from '@/store/modules/ugc-build/types';

/**
 * Drag/drop file form component.
 *
 * This component can be used to allow a user to drag/drop a file onto a page.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
@Component({
    name: 'c-build-thumbnail',
})
export default class BuildThumbnail extends Vue {

    @Prop(Object) public build?: UgcBuildInterface;

    public imageCDN: string = process.env.VUE_APP_IMAGECDN_URL || '/uploads';

    /**
     * Get the URL for this image.
     */
    public url(): string {
        if (!this.build || !this.build.imgUuid) {
            return require('./images/placeholder-item-image.png');
        }

        return this.imageCDN + '/' + this.build.userId + '/' + this.build.id + '/' + this.build.imgUuid;
    }
}

